import { render, staticRenderFns } from "./UpdateTransactionLogsModal.vue?vue&type=template&id=58b34656&scoped=true&"
import script from "./UpdateTransactionLogsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTransactionLogsModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTransactionLogsModal.vue?vue&type=style&index=0&id=58b34656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b34656",
  null
  
)

export default component.exports